import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "tam_last_seen_task";

export function useTaskAlerts(enabled) {
  const [summary, setSummary] = useState(null);
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    if (!enabled) return;
    const poll = () => api.get("/tasks/summary").then(({ data }) => {
      setSummary(data);
      const latest = data.latest;
      if (latest && latest.created_at > (localStorage.getItem(KEY) || "")) setBanner(latest);
    }).catch(() => {});
    poll();
    const t = setInterval(poll, 15000);
    return () => clearInterval(t);
  }, [enabled]);

  const dismiss = () => {
    if (banner) localStorage.setItem(KEY, banner.created_at);
    setBanner(null);
  };
  return { summary, banner, dismiss };
}
